import buildURL from 'axios/lib/helpers/buildURL';
import { constants } from 'utils';
import core from './signer-core';
import makeSecret from './secret.generated';
import { createSigning, hostOf } from './prepare';

const secret = makeSecret(core);

const signing = createSigning({
  apiHost: hostOf(constants.API),
  keyId: secret.keyId,
  sign: secret.sign,
  buildURL
});

/**
 * Gắn ký payload cho một client axios. Gọi TRƯỚC khi client đăng ký response
 * interceptor khác (refresh token), để 401 chữ ký được đánh dấu trước khi tới đó.
 */
// Chỉ có một export có tên: install.js và interceptor.js import theo tên.
// eslint-disable-next-line import/prefer-default-export
export function attachSigning(client) {
  client.interceptors.request.use(signing.prepareRequest);
  client.interceptors.response.use(signing.onResponse, error =>
    signing.onError(error, config => client.request(config))
  );
}
